<template>
  <div
    class="import-strategies"
    >
    <div class="import-strategies-header">IFC Import Strategies</div>
    <div class="import-strategies-content">
      <div class="import-strategies-content-left">
        <div
          v-for="strategy in getUObjects({type: 'bifcimportstrategies', ids: business.bifcimportstrategies})"
          :key="`strategy${strategy.id}`"
          class="import-strategies-list"
          @click="$router.push({name: 'CompanyIFCImportStrategiesDetails', params: {strategy_id: strategy.id}})"
          >
          {{strategy.name}}
        </div>
        <div
          class="import-strategies-list"
          @click="$router.push({name: 'CompanyIFCImportStrategiesCreate'})"
          >
          <v-icon>add</v-icon>
          <div>Add Strategy</div>
        </div>
      </div>
      <div class="import-strategies-content-right">
        <router-view/>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    props: [],
    data: () => ({
    }),
    created() {
      this.requestUObject({
        url: [
          {businesses: this.business.id},
          {bifcimportstrategies: ''},
          {showWithEntitiesNormalized: ''}
        ],
        add_u_object: true
      })
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      business() {
        let current_user = this.$store.getters['Auth/getUser'];
        return this.$store.state.Ultra.businesses[current_user.business.id];
      }
    },
    methods: {
      ...mapActions('Ultra', [
        'requestUObject'
      ]),
    }
  }
</script>
<style>
  .import-strategies {
    width: 100%;
    height: calc(100% - 45px);
  }
  .import-strategies-header {
    font-size: 30px;
  }
  .import-strategies-content {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .import-strategies-content-left {
    width: 30%;
    height: 100%;
    border-right: white 1px solid;
  }
  .import-strategies-content-right {
    width: 70%;
    height: 100%;
  }
  .import-strategies-list {
    display: flex;
    align-items: center;
    height: 45px;
    width: 100%;
    border-bottom: white 1px solid;
    color: white;
    cursor: pointer;
    user-select: none;
  }
  .import-strategies-list:hover {
    background-color: rgba(255,255,255, 0.3)
  }
</style>
